import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { AiRecommendationFragmentDoc } from '../../fragments/generated/AiRecommendation';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateStatusOfRecommendedActionsMutationVariables = Types.Exact<{
  input: Types.UpdateStatusOfRecommendedActionsInput;
}>;


export type UpdateStatusOfRecommendedActionsMutation = { updateStatusOfRecommendedActions: { recommendedActions?: Array<{ id: string, type: Types.RecommendedActionTypeEnum, targetModule: Types.RecommendedActionTargetModuleEnum, status: Types.RecommendedActionStatusEnum, card: { title: string, subTitle: string, reasons: Array<string>, avatar?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, actions?: Array<{ type: Types.RecommendedActionCtaTypeEnum, label: string, identifierId?: string | null, path?: string | null, prefill?: string | null, url?: string | null }> | null } }> | null } };


export const UpdateStatusOfRecommendedActionsDocument = /*#__PURE__*/ gql`
    mutation updateStatusOfRecommendedActions($input: UpdateStatusOfRecommendedActionsInput!) {
  updateStatusOfRecommendedActions(input: $input) {
    recommendedActions {
      ...AiRecommendation
    }
  }
}
    ${AiRecommendationFragmentDoc}
${EntityMediaFragmentDoc}`;

export function useUpdateStatusOfRecommendedActionsMutation() {
  return Urql.useMutation<UpdateStatusOfRecommendedActionsMutation, UpdateStatusOfRecommendedActionsMutationVariables>(UpdateStatusOfRecommendedActionsDocument);
};